// src/components/AccountCreation/Step4_Confirmation.js
import React, { useState } from 'react';
import { PLANS_CONFIG } from './constants';

const Step4_Confirmation = ({ data, setData, nextStep }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempSubscription, setTempSubscription] = useState(data.subscription);

  const price = PLANS_CONFIG[data.subscription.region]?.[data.subscription.deviceType]?.[data.subscription.plan]?.[data.subscription.frequency] || 0;

  const handleSelectionChange = (field, value) => {
    const newSubscription = { ...tempSubscription, [field]: value };
    if (field === 'region' || field === 'deviceType') {
      const newAvailablePlans = PLANS_CONFIG[newSubscription.region]?.[newSubscription.deviceType] || {};
      const firstPlan = Object.keys(newAvailablePlans)[0] || '';
      newSubscription.plan = firstPlan;
      const newAvailableFrequencies = newAvailablePlans[firstPlan] || {};
      newSubscription.frequency = Object.keys(newAvailableFrequencies)[0] || '';
    }
    if (field === 'plan') {
        const newAvailableFrequencies = PLANS_CONFIG[newSubscription.region]?.[newSubscription.deviceType]?.[value] || {};
        newSubscription.frequency = Object.keys(newAvailableFrequencies)[0] || '';
    }
    setTempSubscription(newSubscription);
  };

  const handleEdit = () => {
      setTempSubscription(data.subscription);
      setIsEditing(true);
  }

  const handleSave = () => {
      setData(prevData => ({...prevData, subscription: tempSubscription}));
      setIsEditing(false);
  }
  
  const handleCancelEdit = () => {
      setIsEditing(false);
  }

  const availablePlans = PLANS_CONFIG[tempSubscription.region]?.[tempSubscription.deviceType] || {};
  const availableFrequencies = availablePlans[tempSubscription.plan] || {};

  return (
    <div>
      <h2 className="text-center fw-bold mb-4">Review Your Order</h2>
      <div className="card">
        <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2"><h5 className="card-title mb-0">Subscription Details</h5>{!isEditing && (<button onClick={handleEdit} className="btn btn-sm btn-outline-primary"><i className="bi bi-pencil-square me-1"></i>Edit</button>)}</div>
            {isEditing ? (
                <div className="p-3 bg-light rounded border mb-3">
                    <div className="row g-3">
                        <div className="col-md-6"><label htmlFor="edit-region" className="form-label fw-semibold">Region</label><select id="edit-region" className="form-select" value={tempSubscription.region} onChange={(e) => handleSelectionChange('region', e.target.value)}>{Object.keys(PLANS_CONFIG).map(r => <option key={r} value={r}>{r}</option>)}</select></div>
                        <div className="col-md-6"><label htmlFor="edit-deviceType" className="form-label fw-semibold">Device Type</label><select id="edit-deviceType" className="form-select" value={tempSubscription.deviceType} onChange={(e) => handleSelectionChange('deviceType', e.target.value)}>{Object.keys(PLANS_CONFIG[tempSubscription.region] || {}).map(d => <option key={d} value={d}>{d}</option>)}</select></div>
                        <div className="col-md-6"><label htmlFor="edit-plan" className="form-label fw-semibold">Plan</label><select id="edit-plan" className="form-select" value={tempSubscription.plan} onChange={(e) => handleSelectionChange('plan', e.target.value)} disabled={!Object.keys(availablePlans).length}>{Object.keys(availablePlans).map(p => <option key={p} value={p}>{p}</option>)}</select></div>
                        <div className="col-md-6"><label htmlFor="edit-frequency" className="form-label fw-semibold">Billing Frequency</label><select id="edit-frequency" className="form-select" value={tempSubscription.frequency} onChange={(e) => handleSelectionChange('frequency', e.target.value)} disabled={!Object.keys(availableFrequencies).length}>{Object.keys(availableFrequencies).map(f => <option key={f} value={f} className="text-capitalize">{f}</option>)}</select></div>
                    </div>
                    <div className="d-flex justify-content-end mt-3">
                        <button onClick={handleCancelEdit} className="btn btn-secondary btn-sm me-2">Cancel</button>
                        <button onClick={handleSave} className="btn btn-primary btn-sm">Save Changes</button>
                    </div>
                </div>
            ) : (
                <ul className="list-group list-group-flush mb-3"><li className="list-group-item d-flex justify-content-between"><strong>Plan:</strong> <span className="text-capitalize">{data.subscription.plan}</span></li><li className="list-group-item d-flex justify-content-between"><strong>Device:</strong> <span>{data.subscription.deviceType}</span></li><li className="list-group-item d-flex justify-content-between"><strong>Billing:</strong> <span className="text-capitalize">{data.subscription.frequency}</span></li><li className="list-group-item d-flex justify-content-between h4 text-primary"><strong>Price:</strong> <span>${price}</span></li></ul>
            )}
            <h5 className="card-title">Profile Details</h5><ul className="list-group list-group-flush mb-3"><li className="list-group-item d-flex justify-content-between"><strong>Name:</strong> <span>{data.user.firstName} {data.user.lastName}</span></li><li className="list-group-item d-flex justify-content-between"><strong>Email:</strong> <span>{data.user.email}</span></li></ul>
            <h5 className="card-title">Payment Method</h5><ul className="list-group list-group-flush"><li className="list-group-item d-flex justify-content-between"><strong>Card:</strong> <span>**** **** **** {data.payment.cardNumber.slice(-4)}</span></li><li className="list-group-item d-flex justify-content-between"><strong>Billing Address:</strong> <span>{data.payment.billingAddress}</span></li></ul>
        </div>
      </div>
      <div className="text-end mt-4">
        <button onClick={nextStep} className="btn btn-success">Confirm & Pay</button>
      </div>
    </div>
  );
};

export default Step4_Confirmation;
